import { render } from "./commonContent.vue?vue&type=template&id=05bdf739"
import script from "./commonContent.vue?vue&type=script&lang=js"
export * from "./commonContent.vue?vue&type=script&lang=js"

import "./commonContent.vue?vue&type=style&index=0&id=05bdf739&lang=css"

import exportComponent from "C:\\WorkSpace\\webapp\\vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__